import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../actions/allActions";
import { Loading } from "../components/utils/Loading";
import CertTable from "./allCertsTable/CertTable";
import * as cState from "./certReducer";
import history from "../history/history";
import BreadCrumb from "../components/breadcrumbs/BreadCrumb";
import { BreadRoute } from "../components/breadcrumbs/BreadRoute";

export const AllCerts: React.FC = () => {
  const dispatch = useDispatch();
  const { data, initLoading } = useSelector(cState.getAllCustomerCerts);
  const crumbs = [
    { label: "certmenu", link: "/certmenu" },
    { label: "certs", link: "/certs" },
  ];

  const gotoCert = (certOperationId: string) => {
    history.push(`/certs/${certOperationId}`);
  };

  const getAllCerts = useCallback(() => {
    dispatch(allActions.certActions.getAllCerts());
  }, [dispatch]);

  useEffect(() => {
    getAllCerts();
  }, [getAllCerts]);

  return (
    <div className='container w-screen h-full'>
      <BreadRoute>
        {crumbs.map((c, i) => {
          const last = i + 1 === crumbs.length;
          return (
            <BreadCrumb
              key={c.link}
              label={c.label}
              link={c.link}
              lastChild={last}
            />
          );
        })}
      </BreadRoute>
      <div className='container h-full max-h-11/12 w-full flex justify-center items-center overflow-auto scroller'>
        {initLoading ? (
          <Loading />
        ) : (
          <CertTable
            list={data}
            gotoCert={gotoCert}
            headerRow={
              data.length > 0
                ? [
                    "certOperationId",
                    "certOperationStatus",
                    "certOperationType",
                    "certOperationCreationTime",
                    "mailCount",
                  ]
                : []
            }
          />
        )}
      </div>
    </div>
  );
};

export default AllCerts;
